import React from "react";
import Loader from "../../Loader";

const AdminTable = ({ data, isDataLoading, columns, header = true, handleSort, sortColumn, sortOrder, filterParams, isFilter }) => {
  const thClasses = "p-2 pe-4 text-center border";
  const tdClasses = "text-start align-middle";
  const thStyle = {};
  const tdStyle = {};
  return (
    <>
      <div className="w-100 overflow-auto">
          <table
            className="table-bordered table-hover dataTable no-footer"
            id="myTable1"
            style={{
              minWidth: "100%",
            }}
          >
          {header && handleSort ? (
            <thead>
              <tr style={{ backgroundColor: "#eee" }} >
                {columns?.map((column) => {
                  return (
                    <th
                      tabIndex="0"
                      aria-controls="myTable1"
                      rowSpan="1"
                      colSpan="1"
                      aria-sort={sortColumn === column?.sort ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                      aria-label="SRN Name: activate to sort column"
                      onClick={() => handleSort(column?.sort)}
                      className={`${thClasses} ${column?.thClasses || ""} ${sortColumn === column?.sort ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : column?.sort?'sorting' : "" }`}
                      key={column?.title}
                      // className={`${thClasses} ${column?.thClasses || ""}  align-top`}
                      style={{
                        ...thStyle,
                        ...(column?.thStyles || ""),
                      }}
                      {...(column?.thProps || {})}

                    >
                      {column?.title}
                    </th>
                  );
                })}
              </tr>
            </thead>
          ) : 

          (<thead>
              <tr style={{ backgroundColor: "#eee" }} >
                {columns?.map((column) => {
                  return (
                    <th
                      key={column?.title}
                      className={`${thClasses} ${column?.thClasses || ""}  align-top`}
                      style={{
                        ...thStyle,
                        ...(column?.thStyles || ""),
                      }}
                      {...(column?.thProps || {})}

                    >
                      {column?.title}
                    </th>
                  );
                })}
              </tr>
            </thead>)
        }

          {isDataLoading ? (
            <tbody>
              <tr>
                <td colSpan={columns?.length} align="center">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : data?.length ? (
            data?.map((item, index) => (
              <tbody>
                <tr key={index}>
                  {columns?.map((column, indexElement) => {
                    return (
                      <td
                        key={indexElement}
                        className={`${tdClasses} ${column?.tdClasses || ""}`}

                        style={{
                          ...tdStyle,
                          ...(column?.tdStyle || ""),
                          color:column?.styleProps?.color
                        }}
                        {...(columns?.tdProps || {})}
                      >
                        {column?.value(item, index)}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            ))
          ) : (
            <tbody>
              <tr>
                <td colSpan={columns?.length} align="center" className="p-2 ">
                  No data found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

export default AdminTable;
